const appConfig = window.appConfig as any;

export const getAllowedDomains = (): string[] => {
  const url = window?.location?.href;
  const apiUrl = appConfig?.apiURL?.toLowerCase() || "";

  // const isNonProd = url.includes("nprod"); 
  const isNonProd = url.includes("nprod") || url.includes("localhost");
  const isProd = !isNonProd && url.includes("prod")|| url.includes("malaysiaairports.com");

  const allowed = appConfig?.allowedDomains
    ?.split(",")
    .map((d: string) => d.trim().toLowerCase()) || [];

  if (isNonProd) {
    return allowed
      .filter((d:any) => d === "naditek-myairports.my" || d === "malaysiaairports.com.my" || d === "primuscore.com")
      .map((d:any) => "@" + d);
  } else if (isProd) {
    return allowed
      .filter((d:any) => d === "malaysiaairports.com.my")
      .map((d:any) => "@" + d);
  }

  return [];
};
